import React from 'react';

/**
 * modules/index.js
 * Autodiscovery system for Madmoco Arcade.
 * Automatically scans and registers GAMES based on manifest.json files.
 */

// Use require.context to find all manifests
const manifests_context = require.context('./', true, /manifest\.json$/);

export const autodiscovered_games = manifests_context.keys().map(path => {
    const manifest = manifests_context(path);

    // Get directory from manifest path
    const dir = path.substring(0, path.lastIndexOf('/') + 1);

    // Switch from generic "_module" to specific "_game"
    const componentName = manifest.component || `mmc_${manifest.id}_game`;

    const relativeDir = dir.replace('./', '');

    // Create a lazy-loaded component
    const LazyComponent = React.lazy(() => {
        return import(`./${relativeDir}${componentName}`)
            .catch(err => {
                console.error(`[Arcade] Failed to load game: ${componentName} in ${relativeDir}`, err);
                throw err;
            });
    });

    return { manifest, component: LazyComponent };
});

export default autodiscovered_games;
